import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from './zh-CN'
import enUS from './en-US'

Vue.use(VueI18n)

const messages = {
  zh: zhCN,
  en: enUS
}

// 获取浏览器语言设置
function getDefaultLocale() {
  const savedLocale = localStorage.getItem('language')
  if (savedLocale && messages[savedLocale]) {
    return savedLocale
  }
  
  const browserLocale = navigator.language || navigator.userLanguage
  if (browserLocale.startsWith('zh')) {
    return 'zh'
  }
  return 'en'
}

const i18n = new VueI18n({
  locale: getDefaultLocale(),
  fallbackLocale: 'zh',
  messages
})

export default i18n 